<template>
	<div class="information_list_item van-hairline--bottom " :class="type !=2?'display':''" @click="clickItem">
		<template v-if="type == 2">
			<div class="content_video">
				<h3 class="title van-ellipsis"
					><van-tag v-if="showTag" round type="danger">NEW</van-tag> {{ title }}</h3
				>
				<p class="date">{{ issueDate }}</p>
			</div>
			<div class="video">
				<video controls :poster="`${videoUrl}?vframe/jpg/offset/2`">
					<source :src="videoUrl" type="video/mp4" />
				</video>
			</div>
		</template>
		<template v-else>
			<div class="content">
				<h3 class="title van-multi-ellipsis--l2"
					><van-tag v-if="showTag" round type="danger">NEW</van-tag> {{ title }}</h3
				>
				<p class="date">{{ issueDate }}</p>
			</div>
			<div class="img" v-if="cover">
				<img :src="cover" alt="" />
			</div>
		</template>
	</div>
</template>

<script>
export default {
    name: 'InformationListItem',
    props: ['title', 'issueDate', 'cover', 'type', 'videoUrl', 'showTag'],
    methods: {
        clickItem () {
            this.$emit('click')
        }
    }
}
</script>

<style scoped lang="less">
.display {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.information_list_item {
	padding: 40px 0;
	.content_video {
		height: 88px;
		.date {
			font-family: PingFangSC-Regular;
			font-size: 22px;
			font-weight: normal;
			line-height: 26px;
			color: #999;
			margin-top: 12px;
		}
	}
	.content {
		flex: auto;
		height: 160px;
		word-break: break-all;
		position: relative;
		.date {
			position: absolute;
			bottom: 0;
			left: 0;
			font-family: PingFangSC-Regular;
			font-size: 22px;
			font-weight: normal;
			line-height: 26px;
			color: #999;
		}
	}
	.content_video,
	.content {
		.title {
			font-family: PingFangSC-Medium;
			font-size: 32px;
			font-weight: normal;
			color: #1f2329;
		}
	}
	.title {
		.van-tag {
			display: inline;
			vertical-align: middle;
		}
	}
	.img {
		flex: 0 0 238px;
		text-align: right;
		> img {
			width: 210px;
			height: 160px;
			border-radius: 12px;
		}
	}
	.video {
		height: 411px;
		> video {
			height: 411px;
			width: 100%;
		}
	}
}
</style>
